import { render, staticRenderFns } from "./uf_demand_year_products_project.vue?vue&type=template&id=549cb884&scoped=true"
import script from "./uf_demand_year_products_project.vue?vue&type=script&lang=js"
export * from "./uf_demand_year_products_project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549cb884",
  null
  
)

export default component.exports